export default "__VITE_ASSET__MDJ$0148__"